import React, { Component } from 'react';
import { AlertStatus } from '../../../../domain/watchlist/WatchlistAlertDomains';
import { Dialog } from 'primereact/dialog';
import WatchlistAlertReasonComponent from './WatchlistAlertReasonComponent';
import { AnimatedButton } from '@trlogic/ui-pack';
import WatchlistAlertCloseHeaderComponent from './WatchlistAlertCloseHeaderComponent';
import MessageUtil from '../../../../util/MessageUtil';
import NavigationUtil from '../../../../util/NavigationUtil';
import { FormicaProps, withFormica } from '../../../../helpers/withFormica';
import { RootState } from '../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import WatchlistService from '../../../../service/WatchlistService';
import ServiceContainer from '../../../../config/ServiceContainer';
import { ServiceNames } from '../../../../constant/ServiceNames';
import WatchlistAlertActionComponent from './WatchlistAlertActionComponent';
import { WatchlistBaseModel, WatchlistEntityRequest, WatchlistGeneralRequest, WatchlistIndividualRequest } from '../../../../domain/watchlist/WatchlistDomains';
import LanguageUtil from '../../../../util/LanguageUtil';

class WatchlistAlertCloseComponent extends Component<Props, State> {
  public state: State = new State();
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);

  render() {
    const { closeModel, alertCloseModalVisible } = this.props;
    const { step } = this.state;
    return (
      <Dialog
        visible={alertCloseModalVisible}
        onHide={() => {
          this.setState({ step: 0, reason: undefined });
          closeModel();
        }}
        footer={this.getButtons()}
        closable={false}
        closeOnEscape={true}
        dismissableMask={true}
        className={'w-1/2 h-auto'}
        header={<WatchlistAlertCloseHeaderComponent selectedTab={step} />}
        contentStyle={{ borderBottomRightRadius: 24, borderBottomLeftRadius: 24 }}
        maskStyle={{ borderRadius: 24 }}
        headerStyle={{ borderTopRightRadius: 24, borderTopLeftRadius: 24, background: '#F9FAFB', paddingBottom: 0 }}
      >
        <div className='flex rounded-[24px] items-start justify-center p-[20px]'>{this.getStep()}</div>
      </Dialog>
    );
  }

  private getStep = () => {
    const { step, reason } = this.state;
    const { request, response } = this.props;
    switch (step) {
      case 0:
        return <WatchlistAlertReasonComponent value={reason} onChange={(reason) => this.setState({ reason })} />;
      case 1:
        return <WatchlistAlertActionComponent request={request} response={response} />;
    }
  };

  private getButtons = () => {
    const { step } = this.state;
    const submitLabel =
      step == 1
        ? LanguageUtil.get({ id: 'common.label.close', defaultMessage: 'Close' })
        : LanguageUtil.get({ id: 'common.label.next', defaultMessage: 'Next' });
    const submitOrNextIcon =
      step == 1
        ? LanguageUtil.get({ id: 'common.label.check', defaultMessage: 'Check' })
        : LanguageUtil.get({ id: 'common.label.arrowRight', defaultMessage: 'Arrow-Right' });
    const cancelOrBackLabel =
      step == 0
        ? LanguageUtil.get({ id: 'common.label.cancel', defaultMessage: 'Cancel' })
        : LanguageUtil.get({ id: 'common.label.back', defaultMessage: 'Back' });
    const cancelOrBackIcon =
      step == 0
        ? LanguageUtil.get({ id: 'common.label.close', defaultMessage: 'Close' })
        : LanguageUtil.get({ id: 'common.label.arrowLeft', defaultMessage: 'Arrow-Left' });
    return (
      <div className='flex w-full gap-x-5 px-5 py-5 items-center justify-end gap-[10px]'>
        <AnimatedButton className={'!min-w-[120px]'} customType='secondary' text={cancelOrBackLabel} icon={cancelOrBackIcon} onClick={this.back} />
        <AnimatedButton className={'!min-w-[120px]'} customType='primary' text={submitLabel} icon={submitOrNextIcon} onClick={this.next} />
      </div>
    );
  };

  private back = () => {
    const { step } = this.state;
    if (step == 0) {
      this.setState({ step: 0, reason: undefined });
      this.props.closeModel();
    }
    if (step - 1 >= 0) this.setState({ step: step - 1 });
  };

  private next = async () => {
    const { step } = this.state;
    if (step == 1) {
      await this.closeCase();
    }
    if (step + 1 <= 1) this.setState({ step: step + 1 });
  };

  private closeCase = async () => {
    const { router, status } = this.props;
    const { reason } = this.state;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const id: string | null = previousSearchParams.get('id');
    const type: string | null = previousSearchParams.get('type');
    if (id && type && status) {
      const endpoint = `kyc_${type.toLowerCase()}_log_${NavigationUtil.getTenant()}`;
      await this.watchlistService.closeKycLog(endpoint, id, status, reason).then(() => {
        MessageUtil.success({
          summary: 'Kyc Log',
          detail: <div>Kyc log closed</div>,
        });
      });
    }
  };
}

interface Props extends FormicaProps, ReduxProps {
  status: AlertStatus | undefined;
  alertCloseModalVisible: boolean;
  closeModel: () => void;
  request: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest;
  response: WatchlistBaseModel[];
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  step: number = 0;
  reason: string | undefined;
  loading: boolean = true;
}

export default withFormica(connector(WatchlistAlertCloseComponent));
